var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownArrow = function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.1636L18.207 12.9566L16.793 11.5426L12 16.3356L7.20697 11.5426L5.79297 12.9566L12 19.1636ZM12 13.5136L18.207 7.30658L16.793 5.89258L12 10.6856L7.20697 5.89258L5.79297 7.30658L12 13.5136Z",
    fill: "currentColor"
  })));
};
export default SvgDownArrow;